[
  {
    "value": "0251efe0-94aa-4493-9da2-9943ed09f7dc",
    "label": "Informaticien de gestion | Informaticienne de gestion"
  },
  {
    "value": "0348937d-9263-4358-b7f0-6b6d7748dded",
    "label": "Développeur TED | Développeuse TED"
  },
  {
    "value": "0359def7-d5fa-4ee4-847c-51578be167c6",
    "label": "Business Analyst"
  },
  {
    "value": "03ffdffc-311b-4842-bc61-e7b632324b8f",
    "label": "Web Project Manager DF"
  },
  {
    "value": "042bc455-cc49-4b89-b451-4315e79f6afb",
    "label": "Ingénieur informaticien | Ingénieure informaticienne"
  },
  {
    "value": "043d77ba-f2f6-4dc3-9a06-928f7b7fc859",
    "label": "Coordinateur de test | Coordinatrice de test"
  },
  {
    "value": "04674394-a26b-4ebe-b75e-4b0226a8bf58",
    "label": "Ingénieur des exigences ICT | Ingénieure des exigences ICT"
  },
  {
    "value": "046d92ae-6d3c-4658-978b-07336944eb10",
    "label": "Médiamaticien, Domaine B | Médiamaticienne, Domaine B"
  },
  {
    "value": "04e46d10-b258-410c-9f10-656a11dc787b",
    "label": "Ingénieur de logiciels | Ingénieure de logiciels"
  },
  {
    "value": "05c67652-d718-442e-9383-f9cf87b4b52f",
    "label": "Auditeur informatique | Auditrice informatique"
  },
  {
    "value": "067356e2-cb65-4cbf-b379-93b8c75eb2d4",
    "label": "Développeur d'applications | Développeuse d'applications"
  },
  {
    "value": "067d8d4c-6758-460b-a6e8-ad3d64f932d0",
    "label": "ICT Security Expert DF"
  },
  {
    "value": "06b411e1-62ea-44e9-95d5-44f6d1e3c99d",
    "label": "Analyste des opérations de sécurité informatique"
  },
  {
    "value": "0792da7c-2cb0-4355-bb83-903df69c4d6c",
    "label": "Analyste de système"
  },
  {
    "value": "07a2a1ae-74bf-490f-9fbb-dafb63dd5761",
    "label": "Auditeur des systèmes d’information | Auditrice des systèmes d’information"
  },
  {
    "value": "088ce39e-d3e3-4ce7-9790-7d6e77c89aa8",
    "label": "Manager de programmes ICT"
  },
  {
    "value": "08dabb29-09ad-4492-9c1b-e3b68dbb641b",
    "label": "Médiamaticien, brev. féd. EP | Médiamaticienne, brev. féd. EP"
  },
  {
    "value": "0a49b19a-f905-4894-82d8-0a9c0cc40ca2",
    "label": "Test Designer, ICT"
  },
  {
    "value": "0a617001-85d1-4df9-be7f-c519c6c1825a",
    "label": "Ingénieur d'application | Ingénieure d'application"
  },
  {
    "value": "0bed1718-df3e-406c-9285-057fa86a405f",
    "label": "Informaticien CFC | Informaticienne CFC"
  },
  {
    "value": "0c6d3705-975a-416f-af7b-8460be4f8b6b",
    "label": "Spécialiste en expérience utilisateur"
  },
  {
    "value": "0cb1db70-d675-45c0-a927-ee087d00b809",
    "label": "Téléinformaticien | Téléinformaticienne"
  },
  {
    "value": "0cb4fab9-d57d-498f-846e-69fbb913dc84",
    "label": "Spécialiste réseau"
  },
  {
    "value": "0d909525-36ec-4f97-955c-53d933f07097",
    "label": "Manager de système TED"
  },
  {
    "value": "0dac4e39-5376-4c0d-b373-a8c06cc080f4",
    "label": "Screen Communicator"
  },
  {
    "value": "0dc4fb6e-d099-4ea2-8da6-27d6cde40015",
    "label": "Software Engineer"
  },
  {
    "value": "0f3bc56b-3183-487c-a07c-67c19fdfe8cb",
    "label": "Chef de projet IT | Cheffe de projet IT"
  },
  {
    "value": "0fede063-1499-45ee-bc6a-5a514cb4816c",
    "label": "Analyste d’affaires"
  },
  {
    "value": "10076bb5-a5fe-4190-bb69-fac1d9734d2c",
    "label": "Analyste de systèmes informatiques"
  },
  {
    "value": "1077c52f-a56e-4cc1-95db-189f8c48034e",
    "label": "Business Data Analyst ICT"
  },
  {
    "value": "108b7571-33da-4a66-a1af-1306a7f4e2ad",
    "label": "Linguiste informaticien | Linguiste informaticienne"
  },
  {
    "value": "11733fa4-7f99-4836-909e-38429283c58c",
    "label": "Informaticien CFC, option généraliste | Informaticienne CFC, option généraliste"
  },
  {
    "value": "1173c92d-4a9b-4eb5-aa88-edf5a893badc",
    "label": "Software Manager"
  },
  {
    "value": "13e28d71-6313-4cdf-8ce1-7e59da4f2184",
    "label": "Responsable du système d'exploitation informatique"
  },
  {
    "value": "14bcddd6-06a5-4647-b37d-82e6f4874dc6",
    "label": "Architecte de banques de données"
  },
  {
    "value": "159bfea5-9f2d-4185-a817-2767198f9a91",
    "label": "Administrateur système ICT | Administratrice système ICT"
  },
  {
    "value": "15ab5dc6-45eb-4c99-888f-955eb776a70f",
    "label": "Concepteur de réseaux | Conceptrice de réseaux"
  },
  {
    "value": "1649f151-b479-4033-86a6-792cb8ce9776",
    "label": "Conseiller en informatique | Conseillère en informatique"
  },
  {
    "value": "16df65ab-37b4-4b9b-9703-f24b5b7c9f64",
    "label": "Bachelor in Computer Science"
  },
  {
    "value": "17ea4eca-ed24-4f26-accc-a4522a51fa65",
    "label": "Informaticien en développement d'applications TIC | Informaticienne en développement d'applications TIC"
  },
  {
    "value": "1962dd94-a3bc-45ab-af31-f53f172e9d61",
    "label": "Data Scientist ICT"
  },
  {
    "value": "19794cb7-98cf-4264-b811-907398c3e111",
    "label": "Network Engineer"
  },
  {
    "value": "1a04ee04-f6a8-42a8-bc1d-de86502dadff",
    "label": "System Designer"
  },
  {
    "value": "1a478722-8af2-43b1-99ae-99efd75f24d7",
    "label": "Certified Novell Engineer"
  },
  {
    "value": "1ac22eeb-beef-4294-a41a-f15c8efa67c0",
    "label": "Information Technology-Consultant"
  },
  {
    "value": "1b9f47fa-f50f-4fc7-a99f-74a5e73b5812",
    "label": "Network Administrator"
  },
  {
    "value": "1c27e64f-4ace-4223-acfa-15de83ccaeb4",
    "label": "Concepteur de test | Conceptrice de test"
  },
  {
    "value": "1ca77686-1247-4622-b658-1e23197f0cfe",
    "label": "Spécialiste de communication en informatique"
  },
  {
    "value": "1e2f32bf-4816-4825-801f-977b17750f20",
    "label": "Ingénieur en informatique générale | Ingénieure en informatique générale"
  },
  {
    "value": "1ef7e7d6-8e57-4698-8265-fc165a421153",
    "label": "Responsable de test (ICT)"
  },
  {
    "value": "23d3810e-d614-416b-bb2b-c09519282281",
    "label": "Coordinateur de test, ICT | Coordinatrice de test, ICT"
  },
  {
    "value": "2411742e-dafd-4959-b012-d6795f3c7030",
    "label": "Gestionnaire de bases de données (Database Manager)"
  },
  {
    "value": "24a641e5-7362-4a4b-9468-46fc4fe57761",
    "label": "Ingénieur système ICT | Ingénieure système ICT"
  },
  {
    "value": "25dfda3d-3e8c-48fd-8693-5da0a06f24f3",
    "label": "ICT Software Architect"
  },
  {
    "value": "26dec74f-cff9-4cac-b06c-37e45ead62a5",
    "label": "ICT Outsourcing Manager"
  },
  {
    "value": "279619db-d8c2-47cb-b03b-643ee8583f20",
    "label": "Chef des tests, TIC | Cheffe des tests, TIC"
  },
  {
    "value": "27985559-2206-46f7-8c41-7b1bc404a768",
    "label": "Ingénieur en informatique | Ingénieure en informatique"
  },
  {
    "value": "27f1e8ad-3bad-49b3-931b-330996c4d705",
    "label": "Architecte de l'expérience utilisateur"
  },
  {
    "value": "28549689-9021-41c9-9d5f-7e459cc40912",
    "label": "Intégrateur d’applications"
  },
  {
    "value": "28993a73-01bb-4dd5-88c0-4f2127236587",
    "label": "Conseiller TED | Conseillère TED"
  },
  {
    "value": "28d55767-c0b2-4846-b8a6-1c63f6320435",
    "label": "Administrateur de bases de données | Administratrice de bases de données"
  },
  {
    "value": "28fa1414-1456-4b6f-a865-1e82478f438b",
    "label": "Big Data Analyst ICT"
  },
  {
    "value": "2a58dec2-febc-44b0-bc16-09adb3bc1e87",
    "label": "Analyste en informatique"
  },
  {
    "value": "2ad18078-e917-4f04-a4cd-7c5a47f0e181",
    "label": "Conseiller IT | Conseillère IT"
  },
  {
    "value": "2be3fa59-fe1f-4bbd-ac5d-3ceff6839528",
    "label": "Lic. ès sc. informatiques"
  },
  {
    "value": "2c078313-d191-4b74-8746-480c6e5ad520",
    "label": "Technology Consultant"
  },
  {
    "value": "2c5ab6da-6506-44e8-8e15-77a43cada7e5",
    "label": "Consultant stratégique en technologies de l'information/IT Strategy Consultant | Consultante stratégique en technologies de l'information/IT Strategy Consultant"
  },
  {
    "value": "2cc199b9-8ab0-4ce7-a7ca-d897235d3038",
    "label": "Data Warehouse Engineer"
  },
  {
    "value": "2cd0cd12-b20e-4a4f-b49d-a8ba0656df60",
    "label": "Manager de test ICT"
  },
  {
    "value": "2eb71643-2e98-48fc-8bcd-c45d6795aa17",
    "label": "Responsable de test (ICT)"
  },
  {
    "value": "2f0d6447-d5db-4f5b-b029-9ef998d32029",
    "label": "Assistant de projet TED | Assistante de projet TED"
  },
  {
    "value": "2fbf4731-9e3c-4180-a8a9-5f68737741f0",
    "label": "Responsable des acquisitions ICT"
  },
  {
    "value": "324f67d3-967d-486a-b93c-5b4ee2a0d7c6",
    "label": "Agent de sécurité de l'information | Agente de sécurité de l'information"
  },
  {
    "value": "326c746f-db16-4b2d-901c-5238861ffb73",
    "label": "Cyber Security Specialist"
  },
  {
    "value": "34231e5b-3bca-48a7-913b-e783e9faedae",
    "label": "Bachelor en informatique de gestion"
  },
  {
    "value": "35177ca9-3f50-4b20-b7bb-1d80f28b5b97",
    "label": "Manager de la sécurité informatique"
  },
  {
    "value": "37e434f1-2d64-4eb4-b990-3bd1b469ebc7",
    "label": "Spécialiste de réseau"
  },
  {
    "value": "381d6530-f4e2-4287-9651-f37e331fa641",
    "label": "Réviseur TED | Réviseuse TED"
  },
  {
    "value": "3882d611-1c2b-453e-bff8-078d34284fde",
    "label": "Gestionnaire de test TIC"
  },
  {
    "value": "394e7690-f77e-479f-b6d7-d2d485185f89",
    "label": "Contrôleur informatique | Contrôleuse informatique"
  },
  {
    "value": "3985058b-e8d0-4108-af74-208ccc56280f",
    "label": "Collaborateur PMO ICT | Collaboratrice PMO ICT"
  },
  {
    "value": "3a51effc-480d-474a-9a43-7132b36d0be3",
    "label": "Spécialiste logiciel"
  },
  {
    "value": "3b3dd665-c127-49c4-8c6c-2cf3031fb5b4",
    "label": "Spécialiste de barrières de sécurité (Firewall)"
  },
  {
    "value": "3c0be452-dfd0-471d-bf95-0c5757f9f66a",
    "label": "Chef de projet ICT | Cheffe de projet ICT"
  },
  {
    "value": "3d72cef3-c841-4c34-b1ec-f4817e1313e6",
    "label": "Administrateur de réseau | Administratrice de réseau"
  },
  {
    "value": "3e2e1a20-a50c-45bc-95e2-634b9f1d8c3b",
    "label": "Chef de projet informatique, brev. féd. EP | Cheffe de projet informatique, brev. féd. EP"
  },
  {
    "value": "3ea1e92c-ebbc-4fbc-8e86-d6dd6247a879",
    "label": "ICT Program Manager"
  },
  {
    "value": "3f07f933-a9a4-4517-b9da-61054ef8d19b",
    "label": "Diplôme en informatique"
  },
  {
    "value": "3fede337-b779-48a2-9d47-2743258e93ce",
    "label": "Ingénieur HES, informatique de la communication | Ingénieure HES, informatique de la communication"
  },
  {
    "value": "402e2743-4037-460c-a08d-b9b123db707a",
    "label": "Analyste de test, TIC"
  },
  {
    "value": "40e19932-2e09-4288-8249-971d0b03ec8b",
    "label": "Informaticien de gestion, brev. féd. EP | Informaticienne de gestion, brev. féd. EP"
  },
  {
    "value": "41176643-66b4-4c9a-9b56-89b8c4c62e74",
    "label": "Ingénieur-informaticien | Ingénieure-informaticienne"
  },
  {
    "value": "41200fe4-a081-4eeb-bac5-e4e88112a2a2",
    "label": "ICT Auditor"
  },
  {
    "value": "416939af-5c47-4b4a-b375-78323f59d3e3",
    "label": "Administrateur de base de données | Administratrice de base de données"
  },
  {
    "value": "422ffb4e-a16c-4e5b-ac7d-b5cc086a7a1a",
    "label": "Master en informatique médicale"
  },
  {
    "value": "438c83eb-53ec-4c84-ba4f-7e442678e545",
    "label": "Concepteur de jeux | Conceptrice de jeux"
  },
  {
    "value": "455486ea-b9c1-43ad-9864-fc390ae9f324",
    "label": "Médiamaticien CFC | Médiamaticienne CFC"
  },
  {
    "value": "45f09219-aba6-4966-b64e-b2badeff1ca4",
    "label": "Informaticien de gestion | Informaticienne de gestion"
  },
  {
    "value": "4a43bef6-6f57-41ad-b4bd-a3348a332fc9",
    "label": "Informaticien d'office | Informaticienne d'office"
  },
  {
    "value": "4b45c30a-29f2-47d3-ba2e-6d576559395f",
    "label": "Architecte système"
  },
  {
    "value": "4bf3242c-3eba-4c2b-8a9e-44463d5198e2",
    "label": "Manager système"
  },
  {
    "value": "4c3dab37-ae54-4439-a002-11d585662552",
    "label": "Ingénieur HES en informatique médicale | Ingénieure HES en informatique médicale"
  },
  {
    "value": "4c8935a9-4938-4eb2-bae9-a45505f391c6",
    "label": "Database Engineer"
  },
  {
    "value": "4c93769b-8e04-4ee4-9c74-dc9a233f2189",
    "label": "Ingénieur en systèmes de communication | Ingénieure en systèmes de communication"
  },
  {
    "value": "4e116dfe-ac2f-4ab6-be95-3bb8f8e9bf3e",
    "label": "Spécialiste de banque de données"
  },
  {
    "value": "4e729add-f1f0-412b-9043-25066010d3d4",
    "label": "Ingénieur en sécurité informatique | Ingénieure en sécurité informatique"
  },
  {
    "value": "4ea3b721-6286-4022-bb12-50983477bebe",
    "label": "Ingénieur HES, technologie de l'information | Ingénieure HES, technologie de l'information"
  },
  {
    "value": "4f0b0e15-f945-48e7-a465-ee2b826dee89",
    "label": "Responsable des approvisionnements ICT"
  },
  {
    "value": "4f1046fc-73a9-4c9a-ab3f-00d480b4ba32",
    "label": "Informaticien, brev. féd. EP | Informaticienne, brev. féd. EP"
  },
  {
    "value": "4f6e0a67-ea2c-4d55-9ca7-8dc657383b2b",
    "label": "System Engineer"
  },
  {
    "value": "50ccbd5a-3db0-456b-b93e-d8fc86ca3fb2",
    "label": "Informaticien, développement d'applications | Informaticienne, développement d'applications"
  },
  {
    "value": "5138a874-75f5-4e21-86db-866be522b494",
    "label": "Informaticien médiatique | Informaticienne médiatique"
  },
  {
    "value": "52070565-5029-4379-bdd3-6ae4175f1846",
    "label": "Chef de projet informatique | Cheffe de projet informatique"
  },
  {
    "value": "52d2b154-f28c-49ba-830a-6555b4030073",
    "label": "Analyste de test"
  },
  {
    "value": "52d4ba0f-3027-4410-b12b-0082995e1cb6",
    "label": "ICT System Administrator"
  },
  {
    "value": "542464d8-a2dd-49ec-bfa5-d86b624000ee",
    "label": "Programmeur informatique | Programmeuse informatique"
  },
  {
    "value": "56a4022c-49d6-4e04-922c-e79c6ca2a94b",
    "label": "Ingénieur en exigences TIC | Ingénieure en exigences TIC"
  },
  {
    "value": "56db5e65-c458-4c29-a22a-c3a0ecf805a5",
    "label": "Quality System Manager, ICT"
  },
  {
    "value": "574b6340-9f81-4c67-a7a9-12a571c27388",
    "label": "Administrateur réseau | Administratrice réseau"
  },
  {
    "value": "57d05b1f-5b3f-4bac-9abc-6532a49b192b",
    "label": "Analyste-programmeur | Analyste-programmeuse"
  },
  {
    "value": "580ff660-4225-41e3-9890-3069d6c37b6b",
    "label": "ICT System Engineer"
  },
  {
    "value": "58bd394a-3e87-43f4-ba27-2369038d6111",
    "label": "Manager de la sécurité informatique"
  },
  {
    "value": "593ec797-52f2-4ab6-947b-6b50c0bae360",
    "label": "System Consultant"
  },
  {
    "value": "595b86bd-e9fa-430f-85a2-d910b31d9afb",
    "label": "Chef architecte | Cheffe architecte"
  },
  {
    "value": "595f4a8f-ef2a-4f45-90a4-111616d8ceab",
    "label": "Bachelor en informatique médicale"
  },
  {
    "value": "59c73e1f-5b67-4585-9dae-d7e1f647df84",
    "label": "Manager des opérations de sécurité informatique"
  },
  {
    "value": "59cac1d7-2ef7-4a57-a1c7-e0d40539b4eb",
    "label": "Ingénieur HES en informatique | Ingénieure HES en informatique"
  },
  {
    "value": "5aa77f91-de26-4cac-bf85-63d740974c8d",
    "label": "Datenbank Manager"
  },
  {
    "value": "5b9d5b2d-9ce2-4f73-ac48-83466f33282a",
    "label": "E-Business Consultant"
  },
  {
    "value": "5cad5dc1-cbf6-4e69-9433-5686a95c6d68",
    "label": "Ingénieur en software | Ingénieure en software"
  },
  {
    "value": "5dd06f9a-0a66-47d7-8171-1c654e2973e9",
    "label": "Informaticien | Informaticienne"
  },
  {
    "value": "5eff5de4-fd53-4ca1-943d-e41bcff0d81d",
    "label": "Manager de la qualité ICT"
  },
  {
    "value": "5f6efc13-2edc-43e2-81a9-7cf4ade33283",
    "label": "Spécialiste de système"
  },
  {
    "value": "5f782cbf-540d-4db4-a9a3-ece74dd4b738",
    "label": "Architecte d’entreprise"
  },
  {
    "value": "60df1400-1daf-4055-bdeb-77f0619e2978",
    "label": "Diplôme d'ingénieur informaticien | Diplôme d'ingénieure informaticienne"
  },
  {
    "value": "61149288-2a41-4f97-928f-a80ef7e56f8e",
    "label": "Développeur multimédia | Développeuse multimédia"
  },
  {
    "value": "611ba794-b5db-4faa-ac2e-a368dab5937a",
    "label": "Architecte en expérience utilisateur ICT"
  },
  {
    "value": "61cadff3-992b-4afb-9ecf-d39bd8e19fb3",
    "label": "Informaticien de gestion | Informaticienne de gestion"
  },
  {
    "value": "62290bb5-8a05-4c53-aec2-58b6674dfad6",
    "label": "Chargé de sécurité IT | Chargée de sécurité IT"
  },
  {
    "value": "62b357ef-406e-4697-ab92-028cb559f80a",
    "label": "Ingénieur en informatique de la communication | Ingénieure en informatique de la communication"
  },
  {
    "value": "64e284ae-1725-4ae9-9b92-fe0fcca5b098",
    "label": "Aide-programmeur | Aide-programmeuse"
  },
  {
    "value": "663a75b5-186f-4398-b304-2c86eb810e2a",
    "label": "IT Controller"
  },
  {
    "value": "66680e8c-bb95-441b-bfcb-dcbfc31b823d",
    "label": "Manager de la qualité et de la sécurité"
  },
  {
    "value": "674887a4-9de5-44c8-a84d-a657423a1502",
    "label": "Webproducer"
  },
  {
    "value": "67812cd7-a68e-447c-9322-a909ee94c790",
    "label": "Ingénieur en technologie du langage | Ingénieure en technologie du langage"
  },
  {
    "value": "6845cc73-7f8a-4d9b-a373-3b80e4ada167",
    "label": "ICT Quality Manager"
  },
  {
    "value": "6a3dbf6f-49fb-4fa8-a241-a5b08da6ae83",
    "label": "Administrateur de système | Administratrice de système"
  },
  {
    "value": "6aa5726c-5e53-4f50-96f0-b3ead7c791b0",
    "label": "Screen Communicator, brev. féd. EP"
  },
  {
    "value": "6b689ebf-83c4-4bfd-aced-6587dd439da2",
    "label": "Elaborateur de système CIM | Elaboratrice de système CIM"
  },
  {
    "value": "6b887956-ab86-4434-8144-3515a21a173d",
    "label": "Concepteur en expérience utilisateur | Conceptrice en expérience utilisateur"
  },
  {
    "value": "6bfad08c-ab38-4b24-a8e7-c236f3d11e0e",
    "label": "Spécialiste système ICT"
  },
  {
    "value": "6c03e0de-160f-4773-9e1a-16b6a64c95ed",
    "label": "Spécialiste en sécurité informatique"
  },
  {
    "value": "6c603a6b-cfa7-42f5-b966-d8d7d2225bf3",
    "label": "Responsable de système TED"
  },
  {
    "value": "6caaf749-652e-4f0b-ac7b-1b1eeba169c5",
    "label": "Contrôleur de portefeuille de projets ICT | Contrôleuse de portefeuille de projets ICT"
  },
  {
    "value": "6cad7b18-ac89-40ff-9e46-8e2bff7a5c01",
    "label": "Technicien ES en production multimédia | Technicienne ES en production multimédia"
  },
  {
    "value": "6ce4e5ea-e3d4-47e9-bc5a-85905d4c8eee",
    "label": "Database Administrator"
  },
  {
    "value": "6d44820a-ad1c-42d1-84ef-e1f277a6209b",
    "label": "Technicien sur jeux vidéo | Technicienne sur jeux vidéo"
  },
  {
    "value": "6ec6371b-f8d7-4413-b70f-0779a75c60ec",
    "label": "Spécialiste des réseaux"
  },
  {
    "value": "6f9753b0-ca9c-40d4-92ed-9770aed896d0",
    "label": "Télématicien chef de projet | Télématicienne cheffe de projet"
  },
  {
    "value": "7205e8b3-dabf-4eff-82db-c3f83942eab6",
    "label": "Responsable système/réseau"
  },
  {
    "value": "7208e570-c567-4854-8753-da163c56300d",
    "label": "Manager de portefeuille de projets ICT"
  },
  {
    "value": "722fa507-e874-4edf-8bf8-5aea1dcb738e",
    "label": "Ingénieur ETS, informatique de gestion | Ingénieure ETS, informatique de gestion"
  },
  {
    "value": "723de8c6-2512-47fa-966b-9509e525955d",
    "label": "ICT Strategic Sourcing Manager"
  },
  {
    "value": "72a9541d-5145-43b4-808f-a18d732bdebe",
    "label": "Gestionnaire des données énergétiques"
  },
  {
    "value": "72ca84a5-a231-4fcc-af75-d3c47b7b4636",
    "label": "Programmeur de système informatique | Programmeuse de système informatique"
  },
  {
    "value": "73aa9425-ab97-45f4-a5eb-27fc4e3b4dec",
    "label": "Chercheur en expérience utilisateur | Chercheuse en expérience utilisateur"
  },
  {
    "value": "74601cfc-7f7d-462e-8022-5f8547c06e34",
    "label": "Réviseur informatique | Réviseuse informatique"
  },
  {
    "value": "75129143-9d1b-4350-8d6e-e91d8a08ba4e",
    "label": "Web Consultant"
  },
  {
    "value": "75144e58-0651-4c37-be9a-dbb75ea9d996",
    "label": "Architecte système ICT"
  },
  {
    "value": "760af693-e9b4-4a05-9a3a-10c84a964b27",
    "label": "Consultant en informatique | Consultante en informatique"
  },
  {
    "value": "77bc5844-f3b4-437f-b2ef-2432ab5ce8a3",
    "label": "Ingénieur en automatisation des tests | Ingénieure en automatisation des tests"
  },
  {
    "value": "78f0ae71-55bb-4918-a3f1-1f38ea82001c",
    "label": "Collaborateur Program Office ICT | Collaboratrice Program Office ICT"
  },
  {
    "value": "7a4fef5d-ea18-4711-8bfd-6625cf64bf3b",
    "label": "Chef de projet SIZ | Cheffe de projet SIZ"
  },
  {
    "value": "7ac025e6-5f69-4351-84ec-657b20fa8da7",
    "label": "ICT Security Operations Manager"
  },
  {
    "value": "7aecc877-0b80-4842-80f4-5164fb4dec90",
    "label": "Analyste-programmeur, brev. féd. EP | Analyste-programmeuse, brev. féd. EP"
  },
  {
    "value": "7bb78392-0adb-4468-97cd-291d2b9b5c95",
    "label": "ICT Security Officer"
  },
  {
    "value": "7cdea554-b5cd-414d-b1aa-9f49ac0b885e",
    "label": "Chef de projet informatique | Cheffe de projet informatique"
  },
  {
    "value": "7ce6db0a-3854-4328-b13d-ee156702bca8",
    "label": "Développeur en informatique | Développeuse en informatique"
  },
  {
    "value": "7d5d7572-705b-4d51-b4a9-91f56181c104",
    "label": "Audit informatique"
  },
  {
    "value": "7da093f6-161e-4f71-b7d5-451161407351",
    "label": "Technicien système ICT | Technicienne système ICT"
  },
  {
    "value": "7e0a2de6-e6a4-4138-a3f2-e221cded35bb",
    "label": "Spécialiste en communication de données TIC"
  },
  {
    "value": "7e15f627-308b-4466-acb5-df1fb79a8e21",
    "label": "Réviseur système | Réviseuse système"
  },
  {
    "value": "80efabea-1909-44c5-a730-f49847389d50",
    "label": "Testeur (ICT) | Testeuse (ICT)"
  },
  {
    "value": "80fcf3e8-eb2c-4ed4-95e9-75c30bf3127d",
    "label": "Programmeur-analyste en informatique de gestion | Programmeuse-analyste en informatique de gestion"
  },
  {
    "value": "82116450-8948-4a87-bf01-33ef776e204b",
    "label": "Développeur d'applications | Développeuse d'applications"
  },
  {
    "value": "823a5a51-0175-41c0-b206-c712a253c9ca",
    "label": "Responsable de la sécurité ICT"
  },
  {
    "value": "829a6597-217a-4f5e-95fc-cbc1c40a0646",
    "label": "Master en informatique de gestion"
  },
  {
    "value": "82cea87a-9d4b-4a92-be0f-f5f013cb7feb",
    "label": "Manager du système qualité"
  },
  {
    "value": "839952f4-21bf-419b-a854-ef93dd532e66",
    "label": "Ingénieur en informatique technique | Ingénieure en informatique technique"
  },
  {
    "value": "8410bcb2-c6e7-4a9c-95a4-b3f4e1177cf5",
    "label": "Médiamaticien BP | Médiamaticienne BP"
  },
  {
    "value": "842427d4-68ba-49cd-9a1c-c58ce3c3c5db",
    "label": "Spécialiste en réseaux informatiques"
  },
  {
    "value": "84e858c6-bb52-4167-8cf5-7e7a926a58de",
    "label": "Manager multiprojets ICT"
  },
  {
    "value": "86a35b1d-5a5d-474f-9f4b-461e3b5cc20c",
    "label": "Développeur de banque de données | Développeuse de banque de données"
  },
  {
    "value": "86ac283d-2077-4784-895f-98959c47703a",
    "label": "ICT Testmanager"
  },
  {
    "value": "874fa20a-5544-4936-a8c2-50188c82d18a",
    "label": "Application Consultant"
  },
  {
    "value": "8778ab54-d9d4-402e-81d3-2e51b0ae6d73",
    "label": "ICT Business Analyst"
  },
  {
    "value": "890afce5-eb3f-4da3-b8ee-5b1dbf6bacb9",
    "label": "Consultant ICT | Consultante ICT"
  },
  {
    "value": "898552f1-f0a8-4348-8e5d-fe94322f7dd0",
    "label": "Informaticien en développement d'applications TIC BP | Informaticienne en développement d'applications TIC BP"
  },
  {
    "value": "89d2fcf6-1836-4334-8e16-83535e102cce",
    "label": "Conseiller en Software | Conseillère en Software"
  },
  {
    "value": "89deab36-0054-4d65-a965-4ae89a976cc1",
    "label": "ICT-Requirements-Engineer"
  },
  {
    "value": "89e76aa9-c713-4f69-8ab3-277cfa613a4a",
    "label": "ICT Sourcing Manager"
  },
  {
    "value": "8a827877-b25c-447f-ac54-2fbb46532fde",
    "label": "Administrateur des données | Administratrice des données"
  },
  {
    "value": "8be14089-e3cf-4ffc-8703-c0bb62386afe",
    "label": "Spécialiste de bases de données"
  },
  {
    "value": "8bf7cc88-7b4e-4370-9d7d-535838e01f6a",
    "label": "Business Process Engineer"
  },
  {
    "value": "8bfa68eb-d253-4e7a-8019-c2139da5c4d5",
    "label": "IT-Controller"
  },
  {
    "value": "8c731d5b-bea9-4b3d-8649-15db40bd09e6",
    "label": "Conseiller système | Conseillère système"
  },
  {
    "value": "8d285a53-ed1f-467f-9f55-6b4a4dfda758",
    "label": "Ingénieur en expérience utilisateur | Ingénieure en expérience utilisateur"
  },
  {
    "value": "8d42c2b0-0b3b-4f7f-95f0-4a8cc4645c84",
    "label": "ICT User Experience Architect"
  },
  {
    "value": "8d573a23-20e7-4a89-86a2-ea38090bf1e6",
    "label": "Spécialiste système ICT"
  },
  {
    "value": "8d9835a6-ed7e-45a0-ad57-8727ac57e2aa",
    "label": "Informaticien de gestion, brev. féd. EP | Informaticienne de gestion, brev. féd. EP"
  },
  {
    "value": "8d9af917-45a8-40f7-835f-4c5925870902",
    "label": "Technicien ES, analyste programmeur | Technicienne ES, analyste programmeur"
  },
  {
    "value": "8edb561b-31f6-49bb-9282-033e9342cb93",
    "label": "Chef de projet système | Cheffe de projet système"
  },
  {
    "value": "8f095ea0-816e-4640-9de5-3f6812475043",
    "label": "Développeur en informatique | Développeuse en informatique"
  },
  {
    "value": "90c01193-c0f0-4e14-bf9e-782404a041a5",
    "label": "Data Analyst ICT"
  },
  {
    "value": "915b91b1-a49f-48b7-a6bd-dc4d3a5128be",
    "label": "Contrôleur et testeur d'applications informatiques | Contrôleuse et testeuse d'applications informatiques"
  },
  {
    "value": "92670d1d-3b73-45ba-a509-8493ba5da839",
    "label": "Conseiller ICT | Conseillère ICT"
  },
  {
    "value": "9312482d-c1a8-4e66-84be-8d878c1cc704",
    "label": "Spécialiste de module"
  },
  {
    "value": "93983f56-1efe-4fe4-af7b-a20e9de1704c",
    "label": "Technicien ET, analyste programmeur | Technicienne ET, analyste programmeur"
  },
  {
    "value": "93cd4e0d-6c99-43e8-b1fc-55fe0b3d3a1a",
    "label": "Manager de programmes ICT"
  },
  {
    "value": "93f82c00-60f6-496d-93a6-69f84ac19add",
    "label": "Master en informatique"
  },
  {
    "value": "94007729-001b-4e35-abd5-100d6ef18707",
    "label": "Informaticien CFC, technique des systemes | Informaticienne CFC, technique des systemes"
  },
  {
    "value": "94a30dbf-e98f-412b-9e98-63b054646a29",
    "label": "Chef spécialiste des projets TED | Cheffe spécialiste des projets TED"
  },
  {
    "value": "94a97a43-6468-4c0b-ac2e-52f7bb3ed011",
    "label": "IT Solution Engineer"
  },
  {
    "value": "94ce9e9e-a27a-4bf4-8d3d-82ec72ca1731",
    "label": "Ingénieur en informatique ETS | Ingénieure en informatique ETS"
  },
  {
    "value": "9533bfa6-41be-4487-b9aa-f1fa6e912fc1",
    "label": "Ingénieur HES diplômé en informatique de gestion | Ingénieure HES diplômée en informatique de gestion"
  },
  {
    "value": "95ac2f46-c14f-43da-829b-87b2a097ca8a",
    "label": "ICT Security Expert"
  },
  {
    "value": "96a7be00-3b57-4669-aef1-a37dc3524eb8",
    "label": "IT Security Officer"
  },
  {
    "value": "9754d2cc-1dd8-47bc-a1e6-79b4e81aef3a",
    "label": "Développeur matériel-logiciel | Développeuse matériel-logiciel"
  },
  {
    "value": "9868cf62-4128-445f-ba45-9e67cb1f956b",
    "label": "ICT Systemanalyst"
  },
  {
    "value": "993d2b0a-a91c-4263-b3b8-315f432802aa",
    "label": "Business Engineer"
  },
  {
    "value": "99897fe8-a1b5-4979-adc4-7dd10cea1528",
    "label": "Manager de projet ICT"
  },
  {
    "value": "99ad818f-9525-4020-88c8-4728dc3e0b31",
    "label": "Chef programmeur | Cheffe programmeuse"
  },
  {
    "value": "99d2768d-aa53-418e-bf9a-60138d90f7c0",
    "label": "Ingénieur HES en informatique générale | Ingénieure HES en informatique générale"
  },
  {
    "value": "9c5134d1-475b-4312-9217-82a83f0d300b",
    "label": "Analyste de systèmes informatiques"
  },
  {
    "value": "9cf179fa-9cdc-4828-865a-b0c3084f1b44",
    "label": "Ingénieur en systèmes informatiques | Ingénieure en systèmes informatiques"
  },
  {
    "value": "9d4d4fa4-19fa-4fbb-aac5-0be96d7a7634",
    "label": "Manager des opérations de sécurité informatique"
  },
  {
    "value": "9d512c2f-2b0b-4c3c-b69f-84592f3a63e1",
    "label": "Ingénieur digital | Ingénieure digitale"
  },
  {
    "value": "9d5cce1e-2b5c-4b75-a428-3ed71512f183",
    "label": "Spécialiste en recherches opérationnelles"
  },
  {
    "value": "9dd49019-8c0b-43de-b1b3-71f5fabec745",
    "label": "Responsable de la sécurité informatique"
  },
  {
    "value": "9e12643c-d0bb-4b69-bc57-e1c0a363fd2b",
    "label": "Spécialiste de l'informatique économique"
  },
  {
    "value": "9f530af8-7861-40bc-a116-650735c89b65",
    "label": "Manager de la sécurité ICT"
  },
  {
    "value": "9fc170bb-b485-4d25-8a38-e8d0ef0d52bc",
    "label": "Conseiller SAP | Conseillère SAP"
  },
  {
    "value": "a04eb46b-4871-419a-b9a0-8154aca6903b",
    "label": "Web Engineer"
  },
  {
    "value": "a064aefe-7bef-405e-9e28-5a57ae8a83a2",
    "label": "Manager dans le domaine de l'information"
  },
  {
    "value": "a0f2c352-51e0-480e-a6ce-485290a4e1e2",
    "label": "Employé spécialisé pour l'entretien de systèmes | Employée spécialisée pour l'entretien de systèmes"
  },
  {
    "value": "a1624518-457f-4c3a-96bc-1cbef86052f2",
    "label": "Architecte Data Warehouse"
  },
  {
    "value": "a1e72498-c4a1-4e1e-ab58-203665ce04c1",
    "label": "Architecte de bases de données"
  },
  {
    "value": "a225b513-e148-4442-9e7e-53a1dff43bb1",
    "label": "Assesseur en informatique | Assesseure en informatique"
  },
  {
    "value": "a286a9be-5c1e-417f-8cda-77b0165afb50",
    "label": "Ingénieur en informatique | Ingénieure en informatique"
  },
  {
    "value": "a3e492d6-15d5-42ed-8623-7977cd987682",
    "label": "Architecte de software"
  },
  {
    "value": "a492c9a5-d115-4a43-9a28-43d2bf34fe14",
    "label": "ICT Application Engineer"
  },
  {
    "value": "a4abfddc-309d-4d17-8ac6-4d10d4c6f318",
    "label": "Test Automation Engineer, ICT"
  },
  {
    "value": "a52b14da-6fa0-42ba-8839-88a94bc75a3d",
    "label": "Ingénieur solution informatique | Ingénieure solution informatique"
  },
  {
    "value": "a5c4ef87-eeb6-4bf9-bd56-d07d35b9e379",
    "label": "ICT Requirements Engineer"
  },
  {
    "value": "a70c7a7a-8bca-47c5-8168-06a0c3009d77",
    "label": "Manager système"
  },
  {
    "value": "a70d7fbc-be06-4c8d-9cc2-ea277ab24f78",
    "label": "Technicien en production multimédia | Technicienne en production multimédia"
  },
  {
    "value": "a7b4e905-1e59-4609-84d7-c3e2d1480439",
    "label": "Ingénieur développeur système | Ingénieure développeuse système"
  },
  {
    "value": "a8f1659f-75b6-46c4-b73a-4dbd472a7c16",
    "label": "Informaticien ETS | Informaticienne ETS"
  }
]